import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as drillDownActions from '../actions/arrears-drilldown.actions';
import { ApplicationState } from '@store/application-store';
import { map, filter, tap, take } from 'rxjs';
import { Observable } from 'rxjs';
import { ArrearsDrillDownInstance } from '../reducers/arrears-drilldown.reducer';
import { ArrearsDrillDownParams } from '../models/arrears-drilldown-params.model';
import { selectDrillDownState } from '../selectors/arrears-drilldown.selectors';

@Injectable()
export class ArrearsDrillDownService {

  constructor(protected store: Store<ApplicationState>) { }

  enterDrillDown(widgetId: string, params: ArrearsDrillDownParams): void {
    const payload = new drillDownActions.BeginDrillDownPayload();
    payload.widgetId = widgetId;
    payload.drillDownParams = params;
    this.store.dispatch(new drillDownActions.BeginDrillDown(payload));
  }

  exitDrillDown(widgetId: string): void {
    const payload = new drillDownActions.ExitDrillDownPayload();
    payload.widgetId = widgetId;
    this.store.dispatch(new drillDownActions.ExitDrillDown(payload));
  }

  onEnterDrillDownMode(widgetId: string): Observable<ArrearsDrillDownParams> {
    return this.store.select(selectDrillDownState(widgetId))
      .pipe(
        filter((m: ArrearsDrillDownInstance) => m != undefined && m.inDrillDownMode),
        map((m: ArrearsDrillDownInstance) => m.drillDownParams));
  }

  onExitDrillDown(widgetId: string): Observable<ArrearsDrillDownParams> {
    return this.store.select(selectDrillDownState(widgetId))
      .pipe(
        filter((m: ArrearsDrillDownInstance) => m != undefined && m.inDrillDownMode === false),
        map((m: ArrearsDrillDownInstance) => m.drillDownParams));
  }

}
